import { render, staticRenderFns } from "./eleDetailBox.vue?vue&type=template&id=26c75970&scoped=true"
import script from "./eleDetailBox.vue?vue&type=script&lang=js"
export * from "./eleDetailBox.vue?vue&type=script&lang=js"
import style0 from "./eleDetailBox.vue?vue&type=style&index=0&id=26c75970&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c75970",
  null
  
)

export default component.exports